<template>
  <div class="apiStep-three" data-automation="apiStepThree">
    <div class="x-border-50 x-margin-b">
      <my-head-title :title="$t('HT.apiStepThree.title')"></my-head-title>
      <div class="x-flex-justify x-padding">
        <ux-form
          ref="form"
          :data="formData"
          width="550px"
          :colon="true"
          :rules="rules"
          label-width="110px"
          :hideBtn="true"
        >
          <ux-form-item :label="$t('HT.apiStepThree.type')" prop="type">
            <ux-radio
              v-model="formData.type"
              :options="$opt.serviceType"
              @change="change"
            ></ux-radio>
          </ux-form-item>

          <!-- MOCK -->
          <template v-if="formData.type === 'MOCK'">
            <ux-form-item :label="$t('HT.apiStepThree.http')" prop="mock_http_status">
              <ux-input v-model="formData.mock_http_status" size="small" placeholder=""></ux-input>
            </ux-form-item>
            <ux-form-item :label="$t('HT.apiStepThree.mock')" start prop="mock_http_status">
              <ux-input
                v-model="formData.mock_result"
                type="textarea"
                size="small"
                :autosize="{ minRows: 5, maxRows: 5 }"
              ></ux-input>
            </ux-form-item>
          </template>

          <!-- HTTP -->
          <template v-else>
            <ux-form-item :label="$t('HT.apiStepThree.url')" prop="url">
              <ux-input
                v-model="formData.url"
                size="small"
                :placeholder="$t('HT.apiStepThree.url.placeholder')"
              ></ux-input>
            </ux-form-item>
            <ux-form-item :label="$t('HT.apiStepThree.path')" prop="path">
              <ux-input
                v-model="formData.path"
                size="small"
                :placeholder="$t('HT.apiStepThree.path.placeholder')"
              ></ux-input>
            </ux-form-item>
            <ux-form-item :label="$t('HT.apiStepThree.method')" prop="method">
              <ux-select v-model="formData.method" :options="$opt.httpMethod"></ux-select>
            </ux-form-item>
            <ux-form-item :label="$t('HT.apiStepThree.timeout')" prop="timeout">
              <ux-input
                v-model="formData.timeout"
                size="small"
                :placeholder="$t('HT.apiStepThree.timeout.placeholder')"
              ></ux-input>
            </ux-form-item>
          </template>
        </ux-form>
      </div>
    </div>

    <!-- 后端服务参数配置 -->
    <div class="x-border-50 x-margin-b" v-if="this.transfer_type !== 'PASS_THROUGH'">
      <my-head-title :title="$t('HT.apiStepThree.title2')"></my-head-title>
      <div class="x-padding">
        <ux-table
          class="x-table-add-style"
          ref="table1"
          :showPage="false"
          :data="formData.service_parameters"
          :columns="columns1"
          :emptyText="$t('HT.nodata')"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
    </div>

    <!-- 固定参数 -->
    <div class="x-border-50 x-margin-b">
      <my-head-title :title="$t('HT.apiStepThree.title3')"></my-head-title>
      <div class="x-padding">
        <ux-table
          class="x-table-add-style"
          ref="table2"
          xborder
          :showPage="false"
          :data="formData.fix_parameters"
          :columns="columns2"
          :emptyText="$t('HT.nodata')"
          @addTable="addTable"
          layout="total, sizes, prev, pager, next"
        ></ux-table>
        <ux-button type="primary" style="margin-top: 20px" @click="addTable">{{
          $t('HT.add')
        }}</ux-button>
      </div>
    </div>
  </div>
</template>

<script>
import addFieldInput from './addFieldInput';
import addParamInput from './addParamInput';
export default {
  name: 'apiStepThree',
  components: {
    addFieldInput,
    addParamInput
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          service: {
            type: '', // 服务类型
            url: '', // 请求地址
            path: '', // 请求路径
            method: '', // 请求办法
            timeout: '', //超时时间
            mock_result: '', // mock内容
            mock_http_status: '', // mock响应Http状态码
            service_parameters: [], // 请求参数集合
            fix_parameters: [] // 固定参数集合
          }
        };
      }
    }
  },
  data() {
    return {
      formData: this.data.service,
      transfer_type: this.data.request.transfer_type,
      rules: this.$rul.addApi(),
      columns1: [
        {
          label: this.$t('HT.apiStepThree.lowPressure'),
          prop: 'lowPressure',
          render: (h, params, index) => {
            this.$set(
              this.formData.service_parameters[index],
              'mapping_name',
              this.formData.service_parameters[index]['mapping_name'] ||
                this.formData.service_parameters[index]['name']
            );
            this.$set(
              this.formData.service_parameters[index],
              'mapping_position',
              this.formData.service_parameters[index]['mapping_position'] ||
                this.formData.service_parameters[index]['position']
            );
            return h(addFieldInput, {
              ref: `addForm${index}`,
              props: {
                columns1: this.columns1,
                data: this.formData.service_parameters[index]
              },
              on: {
                del: () => {
                  this.delTable(index);
                }
              }
            });
          }
        },
        {
          label: this.$t('HT.apiStepThree.hightPressure'),
          prop: 'hightPressure',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin1'),
          prop: 'origin',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin2'),
          prop: 'origin',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin3'),
          prop: 'origin',
          tooltip: true
        }
      ],
      columns2: [
        {
          label: this.$t('HT.apiStepThree.lowPressure1'),
          prop: 'lowPressure',
          render: (h, params, index) => {
            return h(addParamInput, {
              ref: `addForm${index}`,
              props: {
                columns2: this.columns2,
                data: this.formData.fix_parameters[index]
              },
              on: {
                del: () => {
                  this.delTable(index);
                }
              }
            });
          }
        },
        {
          label: this.$t('HT.apiStepThree.lowPressure2'),
          prop: 'lowPressure',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin'),
          prop: 'origin',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'origin',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          prop: 'origin',
          tooltip: true
        }
      ]
    };
  },
  created() {
    if (!this.formData.fix_parameters) {
      this.formData.fix_parameters = [];
    }
  },

  methods: {
    /**
     * 改变服务类型
     */
    change() {
      this.$refs['form'].clearValidate();
    },
    /**
     * 验证回调
     */
    confirm() {
      let flag = true;
      function isError(valid) {
        if (!valid) flag = false;
      }
      return new Promise((resolve) => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            for (let i = 0; i < this.formData.service_parameters.length; i++) {
              this.$refs['table1'] &&
                this.$refs['table1'].$refs[`addForm${i}`].$refs['form'].validate((valid) =>
                  isError(valid)
                );
            }
            for (let i = 0; i < this.formData.fix_parameters.length; i++) {
              this.$refs['table2'].$refs[`addForm${i}`].$refs['form'].validate((valid) =>
                isError(valid)
              );
            }
            if (flag) {
              resolve(this.formData);
            }
          }
        });
      });
    },
    /**
     * 新增入参
     */
    addTable() {
      this.formData.fix_parameters.push({
        sort_num: this.formData.fix_parameters.length + 1
      });
    },

    /**
     * 移除当前入参
     */
    delTable(index) {
      this.formData.fix_parameters.splice(index, 1); // 移除当前入参
    }
  },

  watch: {
    data: {
      handler() {
        this.formData = this.data.service;
        this.transfer_type = this.data.request.transfer_type;
        if (!this.formData.fix_parameters) {
          this.formData.fix_parameters = [];
        }
      },
      deep: true
    }
  }
};
</script>
